import { render, staticRenderFns } from "./CommentPanel.vue?vue&type=template&id=5c3a25ef&scoped=true&"
import script from "./CommentPanel.vue?vue&type=script&lang=js&"
export * from "./CommentPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommentPanel.vue?vue&type=style&index=0&id=5c3a25ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a25ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3a25ef')) {
      api.createRecord('5c3a25ef', component.options)
    } else {
      api.reload('5c3a25ef', component.options)
    }
    module.hot.accept("./CommentPanel.vue?vue&type=template&id=5c3a25ef&scoped=true&", function () {
      api.rerender('5c3a25ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/CommentPanel.vue"
export default component.exports